import * as React from 'react';
import Button from '..';
const C = ({ basic, block, icon, disabled, successText, isSubmitting, isError, onClick, children, className, }) => {
    const [controllable, setControllable] = React.useState(true);
    const [isSuccess, setIsSuccess] = React.useState(false);
    const [isFailed, setIsFailed] = React.useState(false);
    const prevIsSubmitting = React.useRef(null);
    const timer = React.useRef();
    React.useEffect(() => {
        if ((prevIsSubmitting.current === false && isSubmitting === true) ||
            (prevIsSubmitting.current === null && isSubmitting === true)) {
            setControllable(false);
            setIsFailed(false);
            setIsSuccess(false);
        }
        else if (prevIsSubmitting.current === true && isSubmitting === false) {
            if (isError) {
                setIsFailed(true);
            }
            else {
                setIsSuccess(true);
            }
            timer.current = window.setTimeout(() => {
                setControllable(true);
            }, 2000);
        }
        prevIsSubmitting.current = !!isSubmitting;
        return () => {
            window.clearTimeout(timer.current);
        };
    }, [isSubmitting]);
    if (!controllable) {
        return (React.createElement(Button, { className: className, block: block, basic: basic, icon: isSuccess ? 'check' : icon, loading: isSubmitting, primary: isSubmitting, success: !isSubmitting && isSuccess, danger: !isSubmitting && isFailed, type: "submit" }, isSuccess && !isSubmitting ? successText || children : children));
    }
    return (React.createElement(Button, { className: className, block: block, disabled: disabled, basic: basic, icon: icon, loading: isSubmitting, primary: true, onClick: onClick, type: "submit" }, children));
};
export default C;
